import config from '@wearetla/tla-essentials-tools/config';

const formatPrice = (price) => {
	// eslint-disable-next-line no-irregular-whitespace
	return `${!isNaN(price) ? parseFloat(price).toFixed(2).replace('.', ',') : price} ${config.mainCurrency.name}`; 
};

export default formatPrice;
